import React from 'react'
import { isNil } from 'lodash'
import styled from 'styled-components'

import Label from '~/truck/label'

interface PageTitleWithTotalProps {
  title: string
  total?: number
}

const TitleContainer = styled.div`
  align-items: baseline;
  display: flex;
  gap: ${props => props.theme.spacing.compact}px;
`

export function PageTitleWithTotal(props: PageTitleWithTotalProps) {
  const { title, total } = props

  const shouldShowTotal = !isNil(total)

  return (
    <TitleContainer>
      <Label as="h1" $textStyle="h4Semibold">
        {title}
      </Label>
      {shouldShowTotal && <Label as="span">{`(${total})`}</Label>}
    </TitleContainer>
  )
}
